import { initSourceDataByCustomEvent } from '../../core/sourceData/thunks.js';
import { addDynamicGlobalTrackingLibraryScript } from '../../../tracking/tools.js';
import { modalNavigationMiddleware } from './modalNavigationMiddleware.js';
import { pageNavigationMiddleware } from '../Page/pageNavigationMiddleware.js';
import { getBrandLogoThunk } from '../../core/thunks.js';
import { setActiveWrapper, WRAPPER_TYPES, } from '../../core/wrapperContext/wrapperContextSlice.js';
import { stepModalNavigationMiddleware } from '../StepModal/stepModalNavigationMiddleware.js';
export const initCommonModalsDependencies = (encodedGTLibraryUrl, logoBrandName, dispatch, payload) => {
    pageNavigationMiddleware.pause();
    stepModalNavigationMiddleware.remove();
    modalNavigationMiddleware.add();
    addDynamicGlobalTrackingLibraryScript(encodedGTLibraryUrl);
    dispatch(initSourceDataByCustomEvent(payload));
    dispatch(setActiveWrapper('modal'));
    dispatch(setActiveWrapper(WRAPPER_TYPES.MODAL));
    dispatch(getBrandLogoThunk(logoBrandName));
};
//# sourceMappingURL=initCommonModalsDependencies.js.map